<!-- Overlay para cerrar sidebar en mobile -->
@if (isMobile() && !collapsed()) {
  <div class="fixed inset-0 bg-black/50 z-30 lg:hidden" (click)="collapsed.set(true)"></div>
}
<aside
  class="h-dvh flex shrink-0 flex-col border-e border-sky-800/40 bg-linear-to-b from-sky-900 via-blue-950 to-slate-950 text-white py-4 sm:py-6 px-2 transition-all duration-300 shadow-2xl"
  [class.fixed]="isMobile()"
  [class.left-0]="isMobile()"
  [class.top-0]="isMobile()"
  [class.z-40]="isMobile()"
  [class.w-64]="(!collapsed() && !isMobile()) || (isMobile() && !collapsed())"
  [class.w-[4.5rem]]="collapsed() && !isMobile()"
  [class.hidden]="isMobile() && collapsed()"
  [class.items-center]="collapsed() && !isMobile()"
  [class.pb-24]="isMobile()"
>
  <div
    class="mb-6 shrink-0 rounded-xl border border-white/10 bg-white/5 p-2 backdrop-blur-sm sm:mb-8"
  >
    <div class="flex items-center justify-end gap-2">
      @if (!collapsed()) {
        <img src="/img/imagotipo-blanco.png" alt="VentaClick" class="h-7 sm:h-8 w-auto" />
      }
      <button
        type="button"
        (click)="toggleSidebar()"
        class="rounded-lg p-2 transition-colors hover:bg-white/10 focus:outline-none"
        [title]="collapsed() ? 'Expandir' : 'Contraer'"
      >
        <i class="bi bi-list text-xl sm:text-2xl"></i>
      </button>
    </div>
  </div>
  <nav class="flex-1 sidebar overflow-y-auto">
    <ul class="space-y-0.5 sm:space-y-1">
      @for (item of menuItems; track item.id) {
        @if (tienePermiso(item)) {
          <li>
            @if (isLink(item)) {
              <!-- Item simple (link directo) -->
              <a
                [routerLink]="item.route"
                (click)="isMobile() && collapsed.set(true)"
                class="flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-xl border border-transparent hover:border-white/10 hover:bg-white/10 font-semibold transition-all duration-150 text-sm sm:text-base"
                routerLinkActive="bg-white/15 border-white/20"
                [hidden]="item.hidden"
              >
                <i [class]="item.icon + ' text-lg sm:text-xl shrink-0'"></i>
                @if (!collapsed()) {
                  <span class="truncate">{{ item.title }}</span>
                }
              </a>
            } @else if (isGroup(item)) {
              <!-- Item grupo (con acordeón) -->
              <button
                type="button"
                (click)="toggleGroup(item.id)"
                class="w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-xl border border-transparent hover:border-white/10 hover:bg-white/10 font-semibold transition-all duration-150 text-sm sm:text-base"
                [title]="collapsed() ? item.title : ''"
                [hidden]="item.hidden"
              >
                <i [class]="item.icon + ' text-lg sm:text-xl shrink-0'"></i>
                @if (!collapsed()) {
                  <span class="flex-1 text-left truncate">{{ item.title }}</span>
                  <i
                    class="bi text-sm transition-transform shrink-0"
                    [class.bi-chevron-down]="!isGroupExpanded(item.id)"
                    [class.bi-chevron-up]="isGroupExpanded(item.id)"
                  ></i>
                }
              </button>
              @if (isGroupExpanded(item.id) && !collapsed()) {
                <!-- Submenú recursivo -->
                <ul
                  class="ml-3 sm:ml-4 mt-1 space-y-0.5 sm:space-y-1 border-s-2 border-white/20 ps-2"
                >
                  @for (subItem of item.items; track subItem.id) {
                    @if (tienePermiso(subItem)) {
                      <li>
                        @if (isLink(subItem)) {
                          <!-- Sub-item link -->
                          <a
                            [routerLink]="subItem.route"
                            (click)="isMobile() && collapsed.set(true)"
                class="flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-lg border border-transparent hover:border-white/10 hover:bg-white/10 font-medium text-xs sm:text-sm transition-all duration-150"
                            routerLinkActive="bg-white/15 border-white/20"
                            [hidden]="subItem.hidden"
                          >
                            <i [class]="subItem.icon + ' text-base sm:text-lg shrink-0'"></i>
                            <span class="truncate">{{ subItem.title }}</span>
                          </a>
                        } @else if (isGroup(subItem)) {
                          <!-- Sub-grupo anidado -->
                          <button
                            type="button"
                            (click)="toggleGroup(subItem.id)"
                              class="w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-lg border border-transparent hover:border-white/10 hover:bg-white/10 font-medium text-xs sm:text-sm transition-all duration-150"
                            [hidden]="subItem.hidden"
                          >
                            <i [class]="subItem.icon + ' text-base sm:text-lg shrink-0'"></i>
                            <span class="flex-1 text-left truncate">{{ subItem.title }}</span>
                            <i
                              class="bi text-xs transition-transform shrink-0"
                              [class.bi-chevron-down]="!isGroupExpanded(subItem.id)"
                              [class.bi-chevron-up]="isGroupExpanded(subItem.id)"
                            ></i>
                          </button>
                          @if (isGroupExpanded(subItem.id)) {
                            <!-- Sub-submenú -->
                            <ul
                              class="ml-3 sm:ml-4 mt-1 space-y-0.5 sm:space-y-1 border-s-2 border-white/15 ps-2"
                            >
                              @for (subSubItem of subItem.items; track subSubItem.id) {
                                @if (tienePermiso(subSubItem)) {
                                  <li>
                                    @if (isLink(subSubItem)) {
                                      <a
                                        [routerLink]="subSubItem.route"
                                        (click)="isMobile() && collapsed.set(true)"
                                        class="flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2 rounded-lg border border-transparent hover:border-white/10 hover:bg-white/10 font-normal text-xs transition-all duration-150"
                                        routerLinkActive="bg-white/15 border-white/20"
                                        [hidden]="subSubItem.hidden"
                                      >
                                        <i
                                          [class]="
                                            subSubItem.icon + ' text-sm sm:text-base shrink-0'
                                          "
                                        ></i>
                                        <span class="truncate">{{ subSubItem.title }}</span>
                                      </a>
                                    }
                                  </li>
                                }
                              }
                            </ul>
                          }
                        }
                      </li>
                    }
                  }
                </ul>
              }
            }
          </li>
        }
      }
    </ul>
  </nav>
  <div class="pt-4 sm:pt-8 shrink-0 border-t border-white/10 mt-4">
    @if (tienePermiso(configMenuItem)) {
      <button
        type="button"
        (click)="toggleGroup(configMenuItem.id)"
        class="w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-xl border border-transparent hover:border-white/10 hover:bg-white/10 font-semibold transition-all duration-150 text-sm sm:text-base"
        [class.bg-white/15]="isGroupExpanded(configMenuItem.id)"
        [class.border-white/20]="isGroupExpanded(configMenuItem.id)"
        [title]="collapsed() ? configMenuItem.title : ''"
      >
        <i [class]="configMenuItem.icon + ' text-lg sm:text-xl shrink-0'"></i>
        @if (!collapsed()) {
          <span class="flex-1 text-left truncate">{{ configMenuItem.title }}</span>
          <i
            class="bi text-sm transition-transform shrink-0"
            [class.bi-chevron-down]="!isGroupExpanded(configMenuItem.id)"
            [class.bi-chevron-up]="isGroupExpanded(configMenuItem.id)"
          ></i>
        }
      </button>
      @if (isGroupExpanded(configMenuItem.id) && !collapsed()) {
        <ul class="ml-3 sm:ml-4 mt-1 space-y-0.5 sm:space-y-1 border-s-2 border-white/20 ps-2">
          @for (subItem of configMenuItem.items; track subItem.id) {
            @if (tienePermiso(subItem)) {
              <li>
                @if (isLink(subItem)) {
                  <a
                    [routerLink]="subItem.route"
                    (click)="isMobile() && collapsed.set(true)"
                    class="flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-lg border border-transparent hover:border-white/10 hover:bg-white/10 font-medium text-xs sm:text-sm transition-all duration-150"
                    routerLinkActive="bg-white/15 border-white/20"
                  >
                    <i [class]="subItem.icon + ' text-base sm:text-lg shrink-0'"></i>
                    <span class="truncate">{{ subItem.title }}</span>
                  </a>
                }
              </li>
            }
          }
        </ul>
      }
    }
    <button
      (click)="onCerrarSesion()"
      class="mt-2 w-full flex items-center gap-2 sm:gap-3 px-2 sm:px-3 py-2.5 rounded-xl border border-red-300/30 bg-red-500/10 text-red-100 hover:bg-red-500/20 font-semibold transition-all duration-150 text-sm sm:text-base"
    >
      <i class="bi bi-box-arrow-right text-lg sm:text-xl shrink-0"></i>
      @if (!collapsed()) {
        <span class="flex-1 text-left truncate">Cerrar Sesión</span>
      }
    </button>
  </div>
</aside>
